import { createAsyncThunk } from '@reduxjs/toolkit';
import { updateInclusiveAccessApiCall } from '../../../inclusive-access-setting/api/inclusive-access.apis';
import { UserSectionOptInOutMetaData } from '../interface/my-digital-products-aggregated.interface';
import { fetchMyDigitalProductsAggregated } from './fetch-my-digital-products-aggregated.thunk';

export type OptInOutAction = 'opt-in' | 'opt-out';

export interface UpdateMyDigitalProductOptInOutArg {
  meta: UserSectionOptInOutMetaData;
  action: OptInOutAction;
}

/**
 * WECOOL-52277 phase 2 — POST opt-in/out for one MDP tile and re-fetch the
 * aggregated data on success. Re-uses the existing /api/v1/optinout client
 * from the self-service settings feature; full refetch (not optimistic) is
 * the team-agreed strategy.
 */
export const updateMyDigitalProductOptInOut = createAsyncThunk(
  'myDigitalProducts/updateOptInOut',
  async (arg: UpdateMyDigitalProductOptInOutArg, thunkAPI) => {
    try {
      const payload = {
        dealId: arg.meta.dealId?.toString(),
        sectionXid: arg.meta.sectionXid,
        isbn: arg.meta.isbn,
        expiryDate: arg.meta.expiryDate,
        sectionId: arg.meta.sectionId,
        sectionUuid: arg.meta.sectionUuid,
        organizationXid: arg.meta.organizationXid,
        instructorXid: arg.meta.instructorXid,
        action: arg.action,
        calledFrom: 'ecomm-ui',
        platform: arg.meta.platform,
      };
      const response = await updateInclusiveAccessApiCall(payload);
      await thunkAPI.dispatch(fetchMyDigitalProductsAggregated({ force: true }));
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
